import React from 'react'
import './HomeContent.css'
const HomeContent = () => {
  return (
      <div className="d-flex flex-column gap-3 justify-content-center align-items-start position-absolute top-50 end-50 ps-5">
            <h4 className='living-life m-0'>Living Life</h4>
            <h1 className='life-in-love fw-bold m-0'>Life in Love With Plants</h1>
            <div className="main-bg text-white m-0 hovers px-3 py-2 rounded-pill">Shop Now</div>
      </div>
  )
}

export default HomeContent
